export const triggerToast = (
  setterFunc: (arg: any) => void,
  message: string,
) => {
  setterFunc(message)
  setTimeout(() => setterFunc(''), 3000)
}
